<template>
  <div class="standard-search-page-view">
    <SearchPageHeader
      :searchOptions="searchOptions"
      :buttonItems="buttonItems"
      :colNum="colNum"
      :exportMenuList="exportMenuList"
      :searchSpan="searchSpan"
      :enableSearch="enableSearch"
      :buttonSize="buttonSize"
      :labelColSpan="labelColSpan"
      :wrapperColSpan="wrapperColSpan"
      :showAdvanced="showAdvanced"
      :showResetButton="showResetButton"
      :exportType="exportType"
      @search="onSearchEvent"
      @reset="onResetEvent"
      @export="exportEvent"
      :queryParams="queryParams"
    >
      <!--搜索头部分的插槽-->
      <template
        v-for="_searchKey in searchSlotKeys"
        v-slot:[_searchKey]="slotProps"
      >
        <slot :name="_searchKey" v-bind="slotProps"></slot>
      </template>
      <template
        v-for="btn in buttonItems"
        v-slot:[btn]="slotProps"
      >
        <slot :name="btn" v-bind="slotProps"></slot>
      </template>
    </SearchPageHeader>
    <div v-if="$slots.operation" class="operation-box" :style="operationBoxStyle">
      <a-space>
        <slot name="operation"></slot>
      </a-space>
    </div>
    <CustomPageTable
      ref="tableList"
      :size="tableSize"
      :rowKey="rowKey"
      :columns="columns"
      :queryParams="queryParams"
      :requestPromise="requestPromise"
      :rowSelection="rowSelection"
      :page-size="pageSize"
      :alert="alert"
      :useScroll="useScroll"
      :extraPaginationName="extraPaginationName"
      :customPagination="customPagination"
    >
      <template v-for="slotName in headerSlots" :slot=slotName slot-scope="item">
        <slot :name="slotName" :data-key="slotName" v-bind="item"></slot>
      </template>
      <template v-for="slotName in cellSlots" :slot="slotName" slot-scope="scope">
        <slot :name="slotName" v-bind="scope"/>
      </template>
      <template v-if="extraPaginationName && $slots[extraPaginationName]" v-slot:[extraPaginationName]>
        <slot :name="extraPaginationName"></slot>
      </template>
    </CustomPageTable>
  </div>
</template>
<script>
/**
 * 标准搜索页面
 */
import SearchPageHeader from './SearchPageHeader.vue'
import CustomPageTable from './CustomPageTable.vue'

export default {
  name: 'StandardSearchPageView',
  components: {
    SearchPageHeader,
    CustomPageTable
  },
  props: {
    /**
     * 搜索配置项
     * {
     *   name:'', //名称
     *   key:'', //搜索字段
     *   type:'', //类型：input/textarea/inputNumber/select/date/rangePicker/timePicker/monthPicker/radio/checkbox/switch/treeSelect/cascader/slot
     *   selectOptions:Array<{label:string,value:string}>, //select/radio/checkbox/cascader使用
     *   format:'', //日期显示格式
     *   valueFormat:'', //日期绑定格式
     * }
     */
    searchOptions: {
      type: Array,
      default: function() {
        return []
      }
    },
    useScroll: {
      type: Boolean,
      default: false
    },
    tableSize: {
      type: String,
      default: 'default'
    },
    buttonSize: {
      type: String,
      default: 'default'
    },
    rowSelection: {
      type: Object,
      default: null
    },
    exportMenuList: {
      type: Array,
      default: () => ['CSV', 'Excel']
    },
    /**
     * 搜索模块的占比，总行是 24
     */
    searchSpan: {
      type: Number,
      default: 0
    },
    colNum: {
      type: Number,
      default: 3
    },
    labelColSpan: {
      type: Number,
      default: 6
    },
    operationTopSpace: {
      type: Number,
      default: -16
    },
    wrapperColSpan: {
      type: Number,
      default: 18
    },
    pageSize: {
      type: Number,
      default: 10
    },
    buttonCol: {
      type: Number,
      default: 0
    },
    showAdvanced: {
      type: Boolean,
      default: true
    },
    showResetButton: {
      type: Boolean,
      default: true
    },
    exportType: {
      type: Number,
      default: 0
    },
    rowKey: {
      type: String,
      default: ''
    },
    requestPromise: {
      type: Function,
      default: undefined
    },
    /**
     * 默认查询参数
     */
    queryParams: {
      type: Object,
      default: function() {
        return {}
      }
    },
    /**
     * 操作栏下的样式
     */
    operationBoxStyle: {
      type: Object,
      default: function() {
        return {}
      }
    },
    columns: {
      type: Array,
      default: function() {
        return []
      }
    },
    enableSearch: {
      type: Boolean,
      default: true
    },
    buttonItems: {
      type: Array,
      default: function() {
        return []
      }
    },
    alert: {
      type: Object,
      default: function() {
        return null
      }
    },
    // 分页附加信息
    extraPaginationName: {
      type: String,
      default: ''
    },
    // 自定义分页显示
    customPagination: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    searchSlotKeys() {
      return this.searchOptions ? this.searchOptions.filter(item => item.type === 'slot').map(item => item.key) : []
    },
    labelCol() {
      return {
        span: this.labelColSpan ? this.labelColSpan : 0
      }
    },
    wrapperCol() {
      return {
        span: this.wrapperColSpan ? this.wrapperColSpan : 0
      }
    },
    // 表头插槽 (slots.title)
    headerSlots() {
      // console.error('headerSlots 执行', this.columns)
      return this.extractSlotKeys(this.columns, 'slots', 'title')
    },
    // 单元格插槽 (scopedSlots.customRender)
    cellSlots() {
      // console.error('cellSlots 执行', this.columns)
      return this.extractSlotKeys(this.columns, 'scopedSlots', 'customRender')
    }
  },

  data() {
    return {}
  },

  mounted() {

  },
  methods: {
    // 统一提取插槽 key
    extractSlotKeys(columnsList, slotType, slotKey) {
      const result = []
      if (columnsList && columnsList.length > 0) {
        columnsList.forEach(item => {
          if (item && item[slotType] && item[slotType][slotKey]) {
            result.push(item[slotType][slotKey])
          }
        })
      }
      return result
    },
    onSearchEvent() {
      this.refresh(true)
    },
    onResetEvent() {
      this.refresh(true)
    },
    resetEvent() {
      this.$emit('reset')
    },
    exportEvent() {
      this.$emit('export')
    },
    refresh(bool = false) {
      this.$refs.tableList.refresh(bool)
    }
  }
}
</script>

<style scoped lang="less">
.standard-search-page-view {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex: 1;
  flex-shrink: 0;

  .operation-box {
    display: flex;
    width: 100%;
    box-sizing: border-box;
    padding: 16px 0;

    .center {
      display: flex;
      align-items: center;
    }
  }

  .operation-align-start {
    justify-content: flex-start;
  }

  .operation-align-end {
    justify-content: flex-end;
  }

}
</style>
